<table>
  <thead>
    <tr>
      <th class="ekspander"><!--vis/skjul detaljer--></th>
      <th class="advarsler"><!--advarsel--></th>
      <th class="navn">{{ "Navn" | translate }}</th>
      <th class="innføringsdato">{{ "Innføringsdato" | translate }}</th>
      <th class="andel">{{ "Eierandel" | translate }}</th>
      <th class="antall">{{ "Antall aksjer" | translate }}</th>
      <th class="klasse">{{ "Klasse" | translate }}</th>
      <th class="nummer">{{ "Nummer" | translate }}</th>
      <th class="representertAv">{{ "Representert av" | translate }}</th>
      <th class="kommentar">{{ "Kommentar" | translate }}</th>
      <th class="meny"><!--meny--></th>
    </tr>
  </thead>
  @for (modell of modell.beholdninger; track modell.aksjeeier.id) {
    <tbody [class.ekspandert]="ekspandertAksjeeierId === modell.aksjeeier.id">
      <tr (click)="visSkjulDetaljer(modell); $event.stopPropagation()">
        <td class="ekspander">
          <button mat-icon-button aria-label="expand row" data-testid="ekspander-knapp" class="mat-medium-icon-button">
            @if (ekspandertAksjeeierId === modell.aksjeeier.id) {
              <mat-icon>keyboard_arrow_up</mat-icon>
            } @else {
              <mat-icon>keyboard_arrow_down</mat-icon>
            }
          </button>
        </td>
        <td class="advarsler">
          @if (modell.harAdvarsler) {
            <i class="icon ion-android-warning" [matTooltip]="modell.advarslerTooltipTekst"></i>
          }
        </td>
        <td class="navn">{{ modell.aksjeeier.navn }}</td>
        <td class="innføringsdato">{{ modell.aksjeeier.naavaerendeBeholdning?.gyldigFraTil?.start ?? null| plaindate:'medium' }}</td>
        <td class="andel">{{ modell.aksjeeier.naavaerendeBeholdning?.eierandel | prosent }}</td>
        <td class="antall">{{ modell.aksjeeier.naavaerendeBeholdning?.antall }}</td>
        <td class="klasse">{{ modell.aksjeeier.naavaerendeBeholdning?.aksjeklasse?.navn }}</td>
        <td class="nummer">{{ modell.aksjeeier.naavaerendeBeholdning?.aksjenummer }}</td>
        <td class="representertAv">{{ modell.aksjeeier.representertAv?.navn }}</td>
        <td class="kommentar">
          <!-- viser trunkert kommentar når ikke ekspandert -->
          <html-formatert [innhold]="modell.aksjeeier.naavaerendeBeholdning?.kommentar" [trunker]="ekspandertAksjeeierId === modell.aksjeeier.id ? 0 : 1"/>
        </td>
        <td class="meny">
          @if (tilgangTilRediger()) {
            <button mat-icon-button [matMenuTriggerFor]="aksjeeierMeny" (click)="$event.stopPropagation()"
              aria-label="Aksjeeiermeny" class="mat-medium-icon-button">
              <mat-icon class="material-symbols-fet">more_vert</mat-icon>
            </button>
            <mat-menu #aksjeeierMeny="matMenu">
              <button mat-menu-item (click)="rediger(modell)">
                <mat-icon>edit</mat-icon>
                <span>{{ "Rediger" | translate }}</span>
              </button>
              @if (modell.aksjeeier.naavaerendeBeholdning) {
                <button mat-menu-item (click)="redigerKommentar(modell.aksjeeier)">
                  <mat-icon>edit</mat-icon>
                  <span>{{ "Rediger kommentar" | translate }}</span>
                </button>
              }
            </mat-menu>
          }
        </td>
      </tr>
      @if ((viserDetaljerFor(modell))) {
        <aksjeeierbok-aksjeeier [aksjeeier]="modell.aksjeeier"></aksjeeierbok-aksjeeier>
      }
    </tbody>
  }

  <tfoot>
    <tr>
      <td class="ekspander"><!--vis/skjul detaljer--></td>
      <td class="advarsler"><!--advarsel--></td>
      <td class="navn">{{ "Totalt" | translate }}</td>
      <td class="innføringsdato"><!--innføringsdato--></td>
      <td class="andel"><!--eierandel--></td>
      <td class="antall">{{ modell.totaltAntallAksjer() }}</td>
      <td class="klasse">
        @if (modell.totaltAntallAksjerPerAksjeklasse().size > 1) {
          <antall-aksjer-per-aksjeklasse [aksjeklasserMedAntall]="modell.totaltAntallAksjerPerAksjeklasse()"/>
        }
      </td>
      <td class="nummer">{{ modell.aksjenummerIBruk()|aksjenummerintervaller }}</td>
      <td class="representertAv"><!--representertAv--></td>
      <td class="kommentar"><!--kommentar--></td>
      <td class="meny"><!--kommentar--></td>
    </tr>
  </tfoot>
</table>

<div class="meldinger-til-bruker">
  @if (modell.aksjenummerIkkeIBruk().length > 0) {
    <inline-melding type="advarsel">
      <div>{{ "Følgende aksjenummer er ikke i bruk:" | translate }}</div>
      <ul>
        @for (intervall of modell.aksjenummerIkkeIBruk(); track $index) {
          <li>{{ intervall|aksjenummerintervaller }}</li>
        }
      </ul>
    </inline-melding>
  }

  @if (modell.aksjenummerSomOverlapper.length > 0) {
    <inline-melding type="feil">
      <div>{{ "Det finnes overlappende aksjenummer:" | translate }}</div>
      @for (overlapp of modell.aksjenummerSomOverlapper; track $index) {
        <div>
          {{ overlapp }}
        </div>
      }
    </inline-melding>
  }
</div>
